<template>
    <div>
        <b-modal id="modal-catatan" title="Catatan" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Catatan untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execCatatan">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-ready" title="Set Ready Line" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Ready Line untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetReady">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-repair" title="Set Repair External" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Repair External untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <b-alert variant="primary" show>
                Unit akan dipindahkan ke lokasi EXTERNAL dengan status REPAIR.
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetRepairExternal">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-scrap" title="Set Scrap" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Scrap untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <b-alert variant="primary" show>
                Unit akan berubah statusnya menjadi SCRAP dan tidak dapat dipulihkan kembali!
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetScrap">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-pindah" title="Set Pindah" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Pindah untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-row class="mt-3 mb-3">
                <b-col>
                    <multiselect v-model="input.wilayah"
                        :options="optWilayah"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Wilayah"
                    />
                </b-col>
                <b-col>
                    <multiselect v-model="input.lokasi"
                        :options="optLokasi"
                        :internal-search="true"
                        deselect-label=""
                        select-label=""
                        label="name"
                        track-by="id"
                        placeholder="Lokasi"
                        :disabled="input.wilayah == null"
                    />
                </b-col>
            </b-row>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <b-alert variant="primary" show>
                Unit yang dipindahkan ke sumur, statusnya akan berubah menjadi SHIPMENT.
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetPindah">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-active" title="Set Installed" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Installed untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetActive">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-set-repair-selesai" title="Set Repair External Selesai" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Repair External Selesai untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <b-form-group label="Warehouse Tujuan">
                <multiselect v-model="input.warehouse"
                    :options="optWarehouse"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih warehouse"
                />
            </b-form-group>
            <b-alert variant="primary" show>
                Unit akan dipindahkan kembali dengan status READY LINE.
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSetRepairSelesai">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-retur" title="Set Retur ke Warehouse" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Set Retur untuk {{ category }}, SN: <strong>{{ unit.sn }}</strong>
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <b-form-group label="Warehouse Tujuan">
                <multiselect v-model="input.warehouse"
                    :options="optWarehouse"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih warehouse"
                />
            </b-form-group>
            <b-alert variant="primary" show>
                Unit akan dipindahkan dengan status RETUR.
            </b-alert>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execRetur">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-switch-on-off" title="Switch On Off" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Ubah status keaktifan menjadi {{ unit.active == true ? "OFF" : "ON" }} untuk unit {{ category }}, SN: <strong>{{ unit.sn }}</strong>.
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execSwitchActive">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-recover-from-scrap" title="Pengaktifan Kembali" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Mengaktifkan kembali ke status RETUR, lokasi WH Lembak, untuk unit {{ category }}, SN: <strong>{{ unit.sn }}</strong>.
            <b-form-group class="mt-2" label="Catatan / Keterangan">
                <b-form-textarea v-model="input.catatan" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ input.catatan.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="input.tanggal" />
            </b-form-group>
            <div class="text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execRecoverFromScrap">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'modal-inventory-actions',
    props: {
        unit: { type: Object, required: true },
        category: { type: String, required: true },
        optWilayah: { type: Array, required: true },
        optWarehouse: { type: Array, required: true }
    },
    data() {
        return {

            isSubmitting: false,

            input: {
                catatan: "",
                tanggal: "",
                wilayah: null,
                lokasi: null,
                warehouse: null
            },

            optLokasi: []

        }
    },
    watch: {

        "input.wilayah": function(newVal) {

            this.input.lokasi = null

            if(newVal == null) {
                return
            }

            this.$axios.get("lokasi/selection/" + newVal.id).then(res => {
                this.optLokasi = res.data
            })

        }

    },
    methods: {

        execCatatan() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/catatan", payload).then(res => {

                this.$helper.toastSuccess(this, "Catatan berhasil disimpan!")
                this.$bvModal.hide("modal-catatan")

                this.input.catatan = ""

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetReady() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/set-ready", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil diset ready line!")
                this.$bvModal.hide("modal-set-ready")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetRepairExternal() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/repair-external", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil dikirim repair external!")
                this.$bvModal.hide("modal-set-repair")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetScrap() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/scrap", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil discrap!")
                this.$bvModal.hide("modal-set-scrap")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetPindah() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            if(this.input.lokasi == null) {
                return this.$helper.toastError(this, "Mohon memilih lokasi tujuan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)
            payload.append("tujuanId", this.input.lokasi.id)

            this.isSubmitting = true
            this.$axios.post("inventory/set-pindah", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil dipindahkan!")
                this.$bvModal.hide("modal-set-pindah")

                this.input.catatan = ""
                this.input.wilayah = null
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetActive() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/set-active", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil diset aktif!")
                this.$bvModal.hide("modal-set-active")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSetRepairSelesai() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            if(this.input.warehouse == null) {
                return this.$helper.toastError(this, "Mohon memilih warehouse tujuan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)
            payload.append("tujuanId", this.input.warehouse.id)

            this.isSubmitting = true
            this.$axios.post("inventory/repair-selesai", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil dikembalikan ke WAREHOUSE!")
                this.$bvModal.hide("modal-set-repair-selesai")

                this.input.catatan = ""
                this.input.warehouse = null
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execRetur() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            if(this.input.warehouse == null) {
                return this.$helper.toastError(this, "Mohon memilih warehouse tujuan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)
            payload.append("tujuanId", this.input.warehouse.id)

            this.isSubmitting = true
            this.$axios.post("inventory/retur", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil diretur ke WAREHOUSE!")
                this.$bvModal.hide("modal-retur")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execSwitchActive() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/switch-active", payload).then(res => {

                this.$helper.toastSuccess(this, "Status unit berhasil diubah menjadi " + (this.unit.active == true ? "OFF" : "ON")) + "!"
                this.$bvModal.hide("modal-switch-on-off")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        execRecoverFromScrap() {

            if(this.$helper.isBlank(this.input.catatan)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            let payload = new FormData()
            payload.append("inventoryId", this.unit.id)
            payload.append("catatan", this.input.catatan)
            payload.append("tanggal", this.input.tanggal)

            this.isSubmitting = true
            this.$axios.post("inventory/recover-from-rts-or-junk", payload).then(res => {

                this.$helper.toastSuccess(this, "Unit berhasil diaktifkan kembali!")
                this.$bvModal.hide("modal-recover-from-scrap")

                this.input.catatan = ""
                this.$emit("should-refresh")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        }

    }
}
</script>
